var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.51 26.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffeaee;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32.49,14.97c-.13,2.34-.81,4.65-2.07,6.66-.33.53-.75,1.16-1.29,1.5-2.04,1.28-4.91,5.49-6.97,1.81-.3-1.07-2.15-2.86-1.19-3.82,6.76-4.06,8.74-9.56,1.55-14.63-3.19-1.73-7.09-.31-9.84,1.72-.49.36-.52.79-.21,1.33.35,1.09,3.22,4.16,1.1,4.52-2.18.54-4.33-.29-6.56.31-2.2,0-6.02,1.64-7.02-1.15C.23,8.72,3.59,4.88,5.45.91c.38-.82,1.43-.95,2.04-.29.73.61,1.23,2.71,2.36,2.17,1.62-.81,3.22-1.65,4.9-2.33C15.94-.02,17.57-.01,18.84,0s2.63.21,3.9.58c2.42.71,4.64,2.08,6.33,4.01,2.47,2.81,3.64,6.63,3.43,10.37Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoIcon);
export default __webpack_public_path__ + "static/media/UndoIcon.a20e4b19eb798bacfb51137117dcbb4c.svg";
export { ForwardRef as ReactComponent };